/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetUserByIdOptions, GetUserByIdResponses } from '../types/GetUserById'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get user by ID (admin only)
 * {@link /v1/user/:user_id}
 */
export function getUserById<ThrowOnError extends boolean = true>(
  options: Options<GetUserByIdOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetUserByIdResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/user/{user_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetUserByIdResponses, ThrowOnError>>,
  )
}
